import React from 'react'

const IconImage = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <path
                d='M11.2917 0.625H1.95833C1.22195 0.625 0.625 1.22195 0.625 1.95833V11.2917C0.625 12.028 1.22195 12.625 1.95833 12.625H11.2917C12.028 12.625 12.625 12.028 12.625 11.2917V1.95833C12.625 1.22195 12.028 0.625 11.2917 0.625Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.62435 5.95817C5.36073 5.95817 5.95768 5.36122 5.95768 4.62484C5.95768 3.88846 5.36073 3.2915 4.62435 3.2915C3.88797 3.2915 3.29102 3.88846 3.29102 4.62484C3.29102 5.36122 3.88797 5.95817 4.62435 5.95817Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.625 8.62496L10.5677 6.56763C10.3176 6.31767 9.97855 6.17725 9.625 6.17725C9.27145 6.17725 8.93237 6.31767 8.68233 6.56763L2.625 12.625'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default IconImage
